/* eslint-disable react/react-in-jsx-scope */
import { Toaster } from "./components/ui/toaster";
import "./global.css";
import "./i18n.tsx";
import AppRoutes from "./routes/AppRoutes";
function App() {
  return (
    <main>
      <AppRoutes />
      <Toaster />
    </main>
  );
}

export default App;
